"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Footer = require("./Footer");
Object.keys(_Footer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Footer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Footer[key];
    }
  });
});
var _FooterLazyLoader = require("./FooterLazyLoader");
Object.keys(_FooterLazyLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FooterLazyLoader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FooterLazyLoader[key];
    }
  });
});
var _FooterLoader = require("./FooterLoader");
Object.keys(_FooterLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FooterLoader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FooterLoader[key];
    }
  });
});
